import {
  ApiControllers,
  IApiControllers
} from './controllers';
import {
  DrinkInDto,
  MealInDto,
  MeasurementInDto,
  TrainingInDto,
  WaterInDto,
} from './generated';

export class Api {

  private readonly _url: string;
  private _controllers: Promise<IApiControllers>;

  private _token: string | null = null;

  constructor (url: string) {
    this._url = url;
  }

  public setToken(token: string | null) {
    window.console.log(token);
    this._token = token;
    this._controllers = new Promise((resolve, reject) => {
      if (token) {
        resolve(new ApiControllers({
          apiKey: token,
          basePath: this._url
        }));
      } else {
        reject("auth token is not available");
      }
    });
  }

  public fetchUser() {
    return this._controllers.then(controllers => controllers.userProfile.getProfileUsingGET())
  }

  public addTraining(data: TrainingInDto) {
    return this._controllers.then(controllers =>
      controllers.training.createTraining(data)
    );
  }

  public addMeal(data: MealInDto, photo: Blob | null = null) {
    return photo
      ? this._authenticatedMultipartRequest(`${this._diaryPageUrl()}/meal/with/image`, data, photo)
      : this._controllers.then(controllers => controllers.meal.createMeal(data));
  }

  public getDiaryPage(date: Date) {
    const dateStr = date.toISOString().slice(0, 10);
    window.console.log('getDiaryPage');
    return this._controllers.then(controlers =>
      controlers.diary.getForDay(dateStr)
    );
  }

  public addWater(data: WaterInDto) {
    return this._controllers.then(controllers => controllers.water.createWater(data));
  }

  public addDrink(data: DrinkInDto) {
    return this._controllers.then(controllers => controllers.drink.createDrink(data));
  }

  public addMeasurement(data: MeasurementInDto) {
    return this._controllers.then(controllers => controllers.measurement.createMeasurement(data));
  }

  public avatar(id: string): Promise<string> {
    return this._authenticatedBlobRequest(`/api/storage/serve/${id}`)
  }

  private _diaryPageUrl() {
    return `/api/diary`;
  }

  private _authenticatedMultipartRequest(path: string, data: {}, image: Blob) {
    return new Promise((resolve, reject) => {
      if (this._token) {
        const formData = new FormData();
        formData.append('meal', new Blob([JSON.stringify(data)], {type: 'application/json'}));
        formData.append('image', image);
        resolve(fetch(`${this._url}${path}`, {
          body: formData,
          headers: {
            'X-Authorization-Firebase': this._token
          },
          method: 'POST',
        }).then(res => {
          if (res.status === 201) {
            return res.json();
          }
          throw res;
        }));
      } else {
        reject('empty auth token');
      }
    });
  }

  private _authenticatedBlobRequest(path: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this._token) {
        resolve(fetch(`${this._url}${path}`, {
          headers: {
            'X-Authorization-Firebase': this._token
          },
        }).then(res => {
          if (res.status === 200) {
            return res.blob();
          }
          throw res;
        }).then(blob =>
          URL.createObjectURL(blob)
        ));
      } else {
        reject();
      }
    });
  }

}


// WEBPACK FOOTER //
// ./src/api/Api.ts